import { createSlice } from '@reduxjs/toolkit';
import { resetAllSlices } from '../Providers/mainStore.slice';
import { fetchUserPasskeys } from './userPasskeys.thunks';

const initialState = {
  passkeys: [],
  loading: false,
  error: null,
};

const userPasskeysSlice = createSlice({
  name: 'userPasskeys',
  initialState,
  reducers: {
    setUserPasskeysState: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(resetAllSlices, () => {
        return initialState;
      })
      .addCase(fetchUserPasskeys.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserPasskeys.fulfilled, (state, action) => {
        state.passkeys = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchUserPasskeys.rejected, (state, action) => {
        state.passkeys = [];
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setUserPasskeysState } = userPasskeysSlice.actions;
export default userPasskeysSlice.reducer;
